import React from 'react'
// REACT TOOLBOX COMPONENTS
import Input from "react-toolbox/lib/input/Input"
import Button from 'react-toolbox/lib/button/Button'
/*** REDUX  ****/
import {connect} from 'react-redux'

/*** REDUX ACTINS ***/

const fields =
    [
        {id: 'id', name: 'Sensor ID'},
        {id: 'SENSOR_ID', name: 'Network ID'},
        {id: 'POSITION', name: 'Position'},
        {id: 'STATUS', name: 'Status'},
        {id: 'F_V', name: 'Firmware version'},
        {id: 'H_V', name: 'Hardware version'},
        {id: 'LAT', name: 'Latitude'},
        {id: 'LON', name: 'Longitude'}
    ];

const initState = {
    id: '',
    generalInfo: {
        value: {
            SENSOR_ID: '',
            POSITION: '',
            STATUS: '',
            F_V: '',
            H_V: ''
        }
    },
    LAT: 1000,
    LON: 1000
};

class GeneralInfo extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            device: !props.isCreate ? (props.device ? props.device : initState) : initState
        };

        this.handleSubmit = this.handleSubmit.bind(this);

    }

    componentDidUpdate(prevProps) {
        if (prevProps.device !== this.props.device && !this.props.isCreate)
            this.setState({...this.state, device: this.props.device});
    }

    handleDisplayInputs() {
        return fields.map((field, key) => {
            if (field.id === 'id')
                return (<Input className="inputForm" type="text" label={field.name} name={field.name}
                               value={this.state.device.id}
                               key={key}
                               onChange={this.handleChange.bind(this, field.id)}
                />);
             else if (field.id === 'LAT')
                return (<Input className="inputForm" type="text" label={field.name} name={field.name}
                               value={this.state.device.LAT.value}
                               key={key}
                               onChange={this.handleChange.bind(this, field.id)}
                />);
            else if (field.id === 'LON')
                return (<Input className="inputForm" type="text" label={field.name} name={field.name}
                               value={this.state.device.LON.value}
                               key={key}
                               onChange={this.handleChange.bind(this, field.id)}
                />);
            else
                return (<Input className="inputForm" type="text" label={field.name} name={field.name}
                               value={this.state.device.generalInfo.value[field.id]}
                               key={key}
                               onChange={this.handleChange.bind(this, field.id)}/>)
        });
    }

    handleChange(name, value) {
        let newState = this.state;
        if (name === 'id') {
            newState.device.id = value;
            this.setState(newState);
        } else if (name === 'LAT') {
            newState.device.LAT.value = value;
            this.setState(newState);
        } else if (name === 'LON') {
            newState.device.LON.value = value;
            this.setState(newState);
        } else {
            newState.device.generalInfo.value[name] = value;
            this.setState(newState);
        }
    };

    handleSubmit() {
        this.props.handleSubmit(this.state.device)
    }

    handleKey(e) {
        if (e.key === 'Enter') {
            e.preventDefault();
            this.handleSubmit();
        }
    }

    render() {
        return (
            <form onKeyDown={this.handleKey.bind(this)}>
                <div className='row subFormBox'>
                    <div className='col-xs-11'>
                        <h2 className="formSubHeader">{this.props.title}</h2>
                        {this.handleDisplayInputs()}
                        <Button className='Margin20px' onClick={this.handleSubmit} label='Submit' primary raised/>
                    </div>
                </div>
            </form>
        )
    }
}

const generalInfoStateToProps = (state) => {
    return {
        generalInfo: state.nodeDetails.generalInfo,
        requiredFields: state.nodeDetails.requiredFields,
        isAdmin: (state.user.role === 'admin'),
    }
};

export default connect(generalInfoStateToProps, null)(GeneralInfo)



// WEBPACK FOOTER //
// ./src/components/DashBoard/AdminNodes/NodeForm/GeneralInfo/GeneralInfo.js